import React from 'react'
import { NewsCard, NewsCardButton } from '@/components/Home'
import { EmtIcon, EmtTypography } from 'emt-components-v2'
import Box from '@mui/material/Box'
import NextLink from 'next/link'
import Grid from '@mui/material/Grid'
import NextImage from 'next/image'
import Blur from '@/assets/img/blur.png'

interface NotificationCardProps {
  iconClassName?: string
  title?: string
  subtitle?: string
  buttonLabel: string
  buttonVariant?: 'text' | 'contained' | 'outlined'
  buttonColor?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning' | 'purple'
  linkHref?: string
  linkRelative?: boolean
  imageUrl?: string
  totalCards: number
  customSx?: object
}

const NotificationCard: React.FC<NotificationCardProps> = ({
  iconClassName,
  title,
  subtitle,
  buttonLabel,
  buttonVariant = 'outlined',
  buttonColor = 'primary',
  linkHref,
  linkRelative,
  imageUrl,
  totalCards,
  customSx = {},
}) => {
  if (!['inherit', 'primary', 'secondary', 'success', 'error', 'info', 'warning', 'purple'].includes(buttonColor)) {
    buttonColor = 'primary'
  }
  if (!['contained', 'outlined', 'text'].includes(buttonVariant)) {
    buttonVariant = 'outlined'
  }

  if (!title) {
    return null
  }

  return (
    <Grid
      item
      xs={12}
      md={6}
      lg={totalCards > 3 ? 3 : 4}
      sx={{
        display: 'flex',
        ...customSx,
      }}
    >
      <NewsCard elevation={0}>
        {iconClassName && <EmtIcon className={`${iconClassName}`} />}
        <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
          <Box sx={{ marginBottom: '5px' }}>
            {title && (
              <EmtTypography variant="body1" fontWeight="bold">
                {title}
              </EmtTypography>
            )}
            {subtitle && (
              <EmtTypography variant="body2" color="greyGradient.250">
                {subtitle}
              </EmtTypography>
            )}
          </Box>
          {linkHref && buttonLabel && (
            <NextLink href={linkHref} passHref target={linkRelative ? undefined : '_blank'}>
              <NewsCardButton size="small" color={buttonColor} variant={buttonVariant}>
                {buttonLabel}
              </NewsCardButton>
            </NextLink>
          )}
        </Box>
        {imageUrl && (
          <Box sx={{ position: 'relative', width: '90px', height: '60px' }}>
            <NextImage
              placeholder="blur"
              blurDataURL={Blur.blurDataURL}
              src={imageUrl}
              quality={70}
              layout="fill"
              objectFit="contain"
              alt="imageAlt"
            />
          </Box>
        )}
      </NewsCard>
    </Grid>
  )
}

export default NotificationCard
